export const STUDIES_REQUEST = 'STUDIES_REQUEST';
export const STUDIES_SUCCESS = 'STUDIES_SUCCESS';
export const STUDIES_FAILURE = 'STUDIES_FAILURE';
